// DV360-specific decoders and tiny lookups. Pure functions / constants — no
// React, no I/O. Imported by the dv360 row builders and by the CLW main
// component when it needs to render DV360 cell content. Mirrors the
// groundtruth/gtConstants.js layout for parity across submodules.

// DV360 amounts are serialised as integer micros (1/1,000,000 of a unit).
export const microsToDollars = (m) => (m == null ? null : Number(m) / 1_000_000);

// Country ID → human name (DV360 uses Google's geo IDs). Small map; falls
// back to the raw id wrapped in "GEO #" so unknown countries still render.
export const COUNTRY_BY_ID = {
  '2840': 'US', '2124': 'Canada', '2826': 'UK', '2036': 'Australia',
  '2276': 'Germany', '2250': 'France', '2392': 'Japan', '2356': 'India',
  '2484': 'Mexico', '2076': 'Brazil', '2380': 'Italy', '2724': 'Spain',
};

export const countryName = (id) => COUNTRY_BY_ID[String(id)] || `GEO ${id}`;

// Tactic-suffix → human label. Tactics in real DV360 plans look like
// '_InMkt', '_RTG_30Min', '_Conv_365days', '_TVS', '_Google'. Strip the
// leading underscore and lightly humanize.
export function humanizeTactic(t) {
  if (!t) return '—';
  const s = String(t).replace(/^_+/, '');
  return s
    .replace(/_/g, ' ')
    .replace(/InMkt/i, 'In-Market')
    .replace(/RTG/i, 'Retargeting')
    .replace(/TVS/i, 'TVS')
    .replace(/Conv\b/i, 'Conversions')
    .replace(/Reimpt/i, 'Re-impression')
    .trim();
}

// Map LINE_ITEM_TYPE_* → format pill key (matches deriveFormat output).
export function lineItemTypeToFormat(t = '') {
  const s = String(t).toUpperCase();
  if (s.includes('VIDEO')) return 'OLV';
  if (s.includes('OTT') || s.includes('CONNECTED')) return 'OTT';
  if (s.includes('AUDIO')) return 'CRM';
  if (s.includes('MOBILE_APP') || s.includes('MOBILE_WEB')) return 'MOB';
  if (s.includes('DISPLAY') || s.includes('NATIVE')) return 'DISP';
  return 'DISP';
}
